module.exports = __webpack_public_path__ + "img/Avatar-8.86e7f264.svg";